// shbz worked
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.priorityCollectionKeywords = /\b(semi|setting|settings|mount)\b/i;
    this.priorityCollectionUrl = '/collections/engagement-ring-settings';
    this.priorityCollectionProductsUrl = `${this.priorityCollectionUrl}/products.json?limit=10`;
    this.input = this.querySelector('input.field__input');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.predictiveSearchResultsArticle = this.querySelector('[data-predictive-search-article]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    const form = this.querySelector('form.search');
    form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));

    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) {
      event.preventDefault();
    } else {
      let searchTerm = this.getQuery();
      if (this.hasPriorityCollectionKeywords(searchTerm)) {
        event.preventDefault();
        window.location.href = this.priorityCollectionUrl;
        return;
      }
      if (/^\d+[a-zA-Z0-9]*$/.test(searchTerm)) {
        event.preventDefault();
        let fetchSearchTerm = `${searchTerm} OR FD${searchTerm} OR FDM${searchTerm} OR FDEN${searchTerm} OR FDENS${searchTerm} OR FDENR${searchTerm}`;
        window.location.href = `/search?q=${encodeURIComponent(fetchSearchTerm)}&type=product&options[prefix]=last&options[fields]=title,product_type,vendor,variants.title,variants.sku`;
      }
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) return;

    if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onKeyup(event) {
    if (!this.getQuery().length) {
      this.close(true);
      $('form.search-modal__form .predictive-search-content').css("display", "none");
    }
    event.preventDefault();
    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allElements = this.querySelectorAll('li');
    let activeElement = this.querySelector('li');

    if (moveUp && !selectedElement) return;

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElement = selectedElement.nextElementSibling || allElements[0];
    } else if (moveUp) {
      activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
    }

    if (activeElement === selectedElement) return;

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.setLiveRegionText(activeElement.textContent);
    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');

    if (selectedProduct) selectedProduct.click();
  }

  hasPriorityCollectionKeywords(searchTerm) {
    return this.priorityCollectionKeywords.test(searchTerm);
  }

  fetchMarkup(url) {
    return fetch(url).then((response) => response.ok ? response.text() : '');
  }

  fetchJson(url) {
    return fetch(url).then((response) => {
      if (!response.ok) {
        throw new Error(response.status);
      }

      return response.json();
    });
  }

  escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  formatMoneyAmount(amount) {
    const numericAmount = Number(amount || 0);
    const currencyCode = window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'USD';

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currencyCode
      }).format(numericAmount);
    } catch (error) {
      return `$${numericAmount.toFixed(2)}`;
    }
  }

  getProductPriceMarkup(product) {
    const variants = Array.isArray(product.variants) ? product.variants : [];

    if (!variants.length) {
      return '';
    }

    const prices = variants
      .map((variant) => Number(variant.price))
      .filter((price) => !Number.isNaN(price));

    if (!prices.length) {
      return '';
    }

    const minPrice = Math.min(...prices);
    const maxPrice = Math.max(...prices);
    const compareAtPrices = variants
      .map((variant) => Number(variant.compare_at_price))
      .filter((price) => !Number.isNaN(price) && price > 0);
    const compareAtPrice = compareAtPrices.length ? Math.max(...compareAtPrices) : 0;

    if (minPrice !== maxPrice) {
      return `<div class="product-price variant-price">${this.formatMoneyAmount(minPrice)} - ${this.formatMoneyAmount(maxPrice)}</div>`;
    }

    const regularPriceMarkup = compareAtPrice > minPrice ? `<div class="product-price product-price--regular">${this.formatMoneyAmount(compareAtPrice)}</div>` : '';
    return `${regularPriceMarkup}<div class="product-price">${this.formatMoneyAmount(minPrice)}</div>`;
  }

  buildPriorityCollectionItem(product, index) {
    const productUrl = `/products/${this.escapeHtml(product.handle)}`;
    const productTitle = this.escapeHtml(product.title);
    const featuredImage = Array.isArray(product.images) && product.images.length ? product.images[0].src : '';
    const imageMarkup = featuredImage ? `<img src="${this.escapeHtml(featuredImage)}" alt="${productTitle}" class="predictive-search__image" loading="lazy">` : '';
    const priceMarkup = this.getProductPriceMarkup(product);

    return `
      <li id="predictive-search-option-${index + 1}" class="predictive-search__list-item" role="option" aria-selected="false">
        <a href="${productUrl}" class="predictive-search__item predictive-search__item--link link link--text" tabindex="-1">
          ${imageMarkup}
          <div class="predictive-search__item-content">
            <h3 class="predictive-search__item-heading">${productTitle}</h3>
            <div class="product-card__price">
              <div class="product-group-price">
                ${priceMarkup}
              </div>
            </div>
          </div>
        </a>
      </li>
    `;
  }

  buildPriorityCollectionMarkup(products) {
    const safeProducts = Array.isArray(products) ? products.slice(0, 10) : [];
    const itemsMarkup = safeProducts.length
      ? safeProducts.map((product, index) => this.buildPriorityCollectionItem(product, index)).join('')
      : '<li id="predictive-search-option-search-keywords" class="predictive-search__list-item no_results" role="option">No products found</li>';

    return `
      <div class="search-top">
        <div class="count-search">${safeProducts.length} results</div>
        <div class="button-view">
          <a class="predictive-search__item-link" data-view-all-product href="${this.priorityCollectionUrl}">
            View all<i class="bwp-icon-next"></i>
          </a>
        </div>
      </div>
      <ul id="predictive-search-results-list" class="predictive-search__results-list list-unstyled" role="listbox" aria-labelledby="predictive-search-products">
        ${itemsMarkup}
      </ul>
      <div class="predictive-search__loading-state" aria-hidden="true"> </div>
    `;
  }

  getSearchResults(searchTerm) {
    let fetchSearchTerm = searchTerm;
    const shouldPrioritizeCollection = this.hasPriorityCollectionKeywords(searchTerm);
    if (/^\d+[a-zA-Z0-9]*$/.test(fetchSearchTerm)) {
      fetchSearchTerm = `${fetchSearchTerm} OR FD${fetchSearchTerm} OR FDM${fetchSearchTerm} OR FDEN${fetchSearchTerm} OR FDENS${fetchSearchTerm} OR FDENR${fetchSearchTerm}`;
    }
    const queryKey = encodeURIComponent(fetchSearchTerm);
    this.setLiveRegionLoadingState();

    let fetchTagUrl = `${routes.predictive_search_url}?q=${queryKey}&${encodeURIComponent('resources[type]')}=product&${encodeURIComponent('resources[options][fields]')}=tag&section_id=predictive-search`;
    let fetchRestUrl = `${routes.predictive_search_url}?q=${queryKey}&${encodeURIComponent('resources[type]')}=product&${encodeURIComponent('resources[options][fields]')}=title,product_type,vendor,variants.title,variants.sku&section_id=predictive-search`;

    if (shouldPrioritizeCollection) {
      this.fetchJson(this.priorityCollectionProductsUrl)
        .then((data) => {
          const products = data && Array.isArray(data.products) ? data.products : [];
          const resultsMarkup = this.buildPriorityCollectionMarkup(products);
          this.renderSearchResults(resultsMarkup, queryKey, this.priorityCollectionUrl);
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    } else {
    Promise.all([
      this.fetchMarkup(fetchTagUrl),
      this.fetchMarkup(fetchRestUrl)
    ])
    .then(([tagText, restText]) => {
      let tagDoc = new DOMParser().parseFromString(tagText || '<div></div>', 'text/html');
      let restDoc = new DOMParser().parseFromString(restText || '<div></div>', 'text/html');

      let tagList = tagDoc.querySelector('#predictive-search-results-list');
      let restList = restDoc.querySelector('#predictive-search-results-list');

      let tagItems = tagList ? Array.from(tagList.querySelectorAll('li.predictive-search__list-item:not(.no_results)')) : [];
      let restItems = restList ? Array.from(restList.querySelectorAll('li.predictive-search__list-item:not(.no_results)')) : [];

      let seenUrls = new Set();
      let combinedItems = [];

      tagItems.forEach(item => {
        let link = item.querySelector('a');
        if (link && link.href) {
            if (!seenUrls.has(link.href)) {
                seenUrls.add(link.href);
                combinedItems.push(item);
            }
        } else {
            combinedItems.push(item);
        }
      });

      restItems.forEach(item => {
        let link = item.querySelector('a');
        if (link && link.href) {
            if (!seenUrls.has(link.href)) {
                seenUrls.add(link.href);
                combinedItems.push(item);
            }
        }
      });

      let targetDoc = tagItems.length > 0 ? tagDoc : restDoc;
      let targetList = targetDoc.querySelector('#predictive-search-results-list');
      let productContainer = targetDoc.querySelector('#predictive-search-product');

      if (combinedItems.length > 0 && targetList) {
          targetList.innerHTML = '';
          combinedItems.slice(0, 10).forEach(item => {
              targetList.appendChild(item);
          });
          
          let countElem = targetDoc.querySelector('.search-top .count-search');
          if (countElem) {
             countElem.textContent = Math.min(combinedItems.length, 10) + ' results';
          }
      }

      const resultsMarkup = productContainer ? productContainer.innerHTML : '';
      this.renderSearchResults(resultsMarkup, queryKey);
    })
    .catch((error) => {
      this.close();
      throw error;
    });
    }

    if (shouldPrioritizeCollection) {
      if (this.predictiveSearchResultsArticle) {
        this.predictiveSearchResultsArticle.innerHTML = '';
      }
      return;
    }

    fetch(`${routes.predictive_search_url}?q=${queryKey}&${encodeURIComponent('resources[type]')}=article&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const articleContainer = new DOMParser().parseFromString(text, 'text/html').querySelector('#predictive-search-blog');
        if (!articleContainer) {
          if (this.predictiveSearchResultsArticle) {
            this.predictiveSearchResultsArticle.innerHTML = '';
          }
          return;
        }
        const resultsMarkup = articleContainer.innerHTML;
        this.renderSearchResultsArticle(resultsMarkup, queryKey);
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup, queryKey, viewAllProductUrl = null) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);
    this.setLiveRegionResults();
    var url = viewAllProductUrl || ('/search?q=' + queryKey + '&type=product&options[prefix]=last&options[fields]=title,product_type,vendor,variants.title,variants.sku');
    $('[data-predictive-search] [data-view-all-product]').attr('href', url);
    this.open();
  }
  renderSearchResultsArticle(resultsMarkup, queryKey) {
    if (this.predictiveSearchResultsArticle) {
      this.predictiveSearchResultsArticle.innerHTML = resultsMarkup;
      this.setAttribute('results', true);
      var url = '/search?q=' + queryKey + '&type=article';
      $('[data-predictive-search-article] [data-view-all-article]').attr('href', url);
      this.setLiveRegionResults();
      this.open();
    }
  }
  setLiveRegionResults() {
    this.removeAttribute('loading');
  }
  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.getElementById('shopify-section-header').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }
  open() {
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    $('form.search-modal__form .predictive-search-content').removeAttr('style')
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }

    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
  }
}

customElements.define('predictive-search', PredictiveSearch);
